var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "bulma-table",
    {
      staticClass: "table is-bordered is-striped is-narrow is-fullwidth",
      attrs: {
        columns: _vm.columns,
        "page-index": _vm.filter.pageIndex,
        "page-size": _vm.filter.pageSize,
        "total-rows": _vm.totalRows,
        "is-loading": _vm.isTableLoading,
        "sort-column": _vm.filter.sortColumn,
        "sort-order": _vm.filter.sortOrder,
        draggable: false,
        "show-pagination": false,
        "is-title-checkable": _vm.editable,
        "title-checkbox-location": "front",
        "is-title-checked": _vm.selectAllChecked,
      },
      on: {
        "title-checkbox-changed": _vm.selectAllItems,
        pageChanged: _vm.onPageChange,
        sort: _vm.sort,
      },
    },
    [
      _vm._l(_vm.activeItems, function (item, index) {
        return _c(
          "tr",
          {
            key: item.quoteItemId,
            class: _vm.isItemDeleted(item) ? "strike-through-line" : "",
          },
          [
            _vm.editable
              ? _c(
                  "td",
                  { staticClass: "has-vertical-middle is-content-width" },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "pretty p-icon p-curve p-smooth m-0 p-bigger",
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: item.isSelected,
                              expression: "item.isSelected",
                            },
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            checked: Array.isArray(item.isSelected)
                              ? _vm._i(item.isSelected, null) > -1
                              : item.isSelected,
                          },
                          on: {
                            change: function ($event) {
                              var $$a = item.isSelected,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      item,
                                      "isSelected",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      item,
                                      "isSelected",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(item, "isSelected", $$c)
                              }
                            },
                          },
                        }),
                        _c("div", { staticClass: "state p-primary" }, [
                          _c("i", { staticClass: "icon mdi mdi-check" }),
                          _c("label"),
                        ]),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
            _c(
              "td",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.$userInfo.isSupportUser,
                    expression: "$userInfo.isSupportUser",
                  },
                ],
                staticClass:
                  "has-vertical-middle has-text-right linenumber-input",
              },
              [
                item.isAdded
                  ? _c("vue-numeric", {
                      staticClass: "input has-text-right",
                      class: _vm.defaultRowColourClass(item),
                      attrs: { precision: 0, separator: "" },
                      model: {
                        value: item.lineNumber,
                        callback: function ($$v) {
                          _vm.$set(item, "lineNumber", _vm._n($$v))
                        },
                        expression: "item.lineNumber",
                      },
                    })
                  : _c("span", [_vm._v(_vm._s(item.lineNumber))]),
              ],
              1
            ),
            _c("td", { staticClass: "has-vertical-middle itemno-input" }, [
              item.isAdded
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: item.itemNo,
                        expression: "item.itemNo",
                      },
                    ],
                    staticClass: "input",
                    class: [
                      _vm.defaultRowColourClass(item),
                      _vm.$v.activeItems.$each[index].itemNo.required
                        ? ""
                        : "is-danger",
                    ],
                    attrs: { placeholder: "Item No." },
                    domProps: { value: item.itemNo },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(item, "itemNo", $event.target.value)
                      },
                    },
                  })
                : _c("span", [_vm._v(_vm._s(item.itemNo))]),
            ]),
            _c("td", { class: ["has-vertical-middle itemdesc-input"] }, [
              item.isAdded
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: item.itemDesc,
                        expression: "item.itemDesc",
                      },
                    ],
                    staticClass: "input",
                    class: [
                      _vm.defaultRowColourClass(item),
                      _vm.$v.activeItems.$each[index].itemDesc.required
                        ? ""
                        : "is-danger",
                    ],
                    attrs: { placeholder: "Item Description" },
                    domProps: { value: item.itemDesc },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(item, "itemDesc", $event.target.value)
                      },
                    },
                  })
                : _c("span", [_vm._v(_vm._s(item.itemDesc))]),
            ]),
            _c("td", { staticClass: "has-vertical-middle has-text-centered" }, [
              _vm.editable && !_vm.isItemDeleted(item)
                ? _c(
                    "div",
                    {
                      staticClass:
                        "pretty p-icon p-curve p-smooth m-0 p-bigger",
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: item.reportOnly,
                            expression: "item.reportOnly",
                          },
                        ],
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(item.reportOnly)
                            ? _vm._i(item.reportOnly, null) > -1
                            : item.reportOnly,
                        },
                        on: {
                          change: function ($event) {
                            var $$a = item.reportOnly,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    item,
                                    "reportOnly",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    item,
                                    "reportOnly",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(item, "reportOnly", $$c)
                            }
                          },
                        },
                      }),
                      _c("div", { staticClass: "state p-primary" }, [
                        _c("i", { staticClass: "icon mdi mdi-check" }),
                        _c("label"),
                      ]),
                    ]
                  )
                : _c("span", { staticClass: "icon has-text-info" }, [
                    _c("i", {
                      staticClass: "mdi mdi-24px",
                      class: [item.reportOnly ? "mdi-check" : ""],
                    }),
                  ]),
            ]),
            _c(
              "td",
              {
                staticClass:
                  "has-vertical-middle has-text-centered is-content-width",
              },
              [
                !item.deleteOtherItem &&
                !_vm.innerValue.readOnly &&
                _vm.editable &&
                !_vm.isItemDeleted(item)
                  ? _c("div", { staticClass: "select" }, [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: item.mark,
                              expression: "item.mark",
                            },
                          ],
                          class: _vm.defaultRowColourClass(item),
                          attrs: { disabled: item.deleteOtherItem },
                          on: {
                            change: [
                              function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  item,
                                  "mark",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              },
                              function ($event) {
                                return _vm.onPartConditionChange(index, item)
                              },
                            ],
                          },
                        },
                        _vm._l(_vm.partTypes, function (typeObject, type) {
                          return _c(
                            "option",
                            {
                              key: typeObject.value,
                              attrs: { title: typeObject.description },
                              domProps: { value: typeObject.value },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$filters.formatPartCondition(type))
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                    ])
                  : _c("span", [
                      _vm._v(_vm._s(_vm.$filters.formatPartType(item.mark))),
                    ]),
              ]
            ),
            _c(
              "td",
              { staticClass: "has-vertical-middle has-text-right qty-input" },
              [
                !_vm.innerValue.readOnly &&
                _vm.editable &&
                !_vm.isItemDeleted(item)
                  ? _c("vue-numeric", {
                      staticClass: "input has-text-right",
                      class: _vm.defaultRowColourClass(item),
                      attrs: {
                        minus: _vm.innerValue.subQuoteNo !== 0,
                        precision: 0,
                      },
                      on: {
                        input: function ($event) {
                          return _vm.updateValue(index, item)
                        },
                      },
                      model: {
                        value: item.itemQuantity,
                        callback: function ($$v) {
                          _vm.$set(item, "itemQuantity", _vm._n($$v))
                        },
                        expression: "item.itemQuantity",
                      },
                    })
                  : _c("span", [_vm._v(_vm._s(item.itemQuantity))]),
              ],
              1
            ),
            _c(
              "td",
              { staticClass: "has-vertical-middle has-text-right money-input" },
              [
                !_vm.innerValue.readOnly &&
                _vm.editable &&
                !_vm.isItemDeleted(item)
                  ? _c("vue-numeric", {
                      staticClass: "input has-text-right",
                      class: _vm.defaultRowColourClass(item),
                      attrs: { minus: true, precision: 2 },
                      on: {
                        input: function ($event) {
                          return _vm.updateMarkup(index, item)
                        },
                      },
                      model: {
                        value: item.value,
                        callback: function ($$v) {
                          _vm.$set(item, "value", _vm._n($$v))
                        },
                        expression: "item.value",
                      },
                    })
                  : _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$filters.formatNumber(
                            item.value,
                            _vm.$userInfo.locale
                          )
                        )
                      ),
                    ]),
              ],
              1
            ),
            _c(
              "td",
              { staticClass: "has-vertical-middle has-text-right" },
              [
                !item.deleteOtherItem &&
                !_vm.innerValue.readOnly &&
                _vm.editable &&
                !_vm.isItemDeleted(item)
                  ? _c("vue-numeric", {
                      staticClass: "input has-text-right",
                      class: _vm.defaultRowColourClass(item),
                      attrs: {
                        minus: true,
                        precision: 2,
                        disabled: item.deleteOtherItem,
                      },
                      on: {
                        input: function ($event) {
                          return _vm.updateTotal()
                        },
                      },
                      model: {
                        value: item.markupValue,
                        callback: function ($$v) {
                          _vm.$set(item, "markupValue", _vm._n($$v))
                        },
                        expression: "item.markupValue",
                      },
                    })
                  : _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$filters.formatNumber(
                            item.markupValue,
                            _vm.$userInfo.locale
                          )
                        )
                      ),
                    ]),
              ],
              1
            ),
            _c("td", { staticClass: "has-vertical-middle has-text-right" }, [
              _vm._v(
                _vm._s(
                  _vm.$filters.formatNumber(
                    item.itemQuantity * item.markupValue,
                    _vm.$userInfo.locale
                  )
                )
              ),
            ]),
            _c("td", { staticClass: "has-vertical-middle partno-input" }, [
              !item.deleteOtherItem &&
              !_vm.innerValue.readOnly &&
              _vm.editable &&
              !_vm.isItemDeleted(item)
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: item.partNo,
                        expression: "item.partNo",
                      },
                    ],
                    staticClass: "input is-uppercase",
                    class: _vm.defaultRowColourClass(item),
                    attrs: {
                      placeholder: "Part No.",
                      disabled: item.deleteOtherItem,
                    },
                    domProps: { value: item.partNo },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(item, "partNo", $event.target.value)
                      },
                    },
                  })
                : _c("span", [_vm._v(_vm._s(item.partNo))]),
            ]),
            _c(
              "td",
              {
                staticClass:
                  "has-vertical-middle has-text-centered is-content-width",
              },
              [_vm._v(_vm._s(item.quantityOrdered))]
            ),
            _c(
              "td",
              {
                staticClass:
                  "has-vertical-middle has-text-centered is-content-width",
              },
              [_vm._v(_vm._s(item.quantityReceived))]
            ),
            _c(
              "td",
              {
                staticClass:
                  "has-vertical-middle has-text-centered is-content-width",
              },
              [_vm._v(_vm._s(item.quantityReturned))]
            ),
            _c("td", { staticClass: "has-vertical-middle has-text-right" }, [
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.$filters.formatNumber(
                      item.buyPrice,
                      _vm.$userInfo.locale
                    )
                  )
                ),
              ]),
            ]),
            _c(
              "td",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.$userInfo.isSupportUser,
                    expression: "$userInfo.isSupportUser",
                  },
                ],
                staticClass:
                  "has-vertical-middle has-text-centered is-content-width",
              },
              [_vm._v(_vm._s(item.itemStatus))]
            ),
            _vm.editable
              ? _c(
                  "td",
                  {
                    staticClass:
                      "has-vertical-middle has-text-centered is-content-width",
                  },
                  [
                    _c("div", { staticClass: "icon-container" }, [
                      !_vm.isItemDeleted(item) &&
                      item.isDeleted !== true &&
                      item.deleted !== true
                        ? _c(
                            "button",
                            {
                              staticClass:
                                "button is-danger is-small is-inverted tooltip",
                              attrs: {
                                disabled:
                                  _vm.innerValue.readOnly ||
                                  _vm.isItemDeleted(item),
                                "data-tooltip": "Delete",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.deleteItem(item, index)
                                },
                              },
                            },
                            [
                              _c("span", { staticClass: "icon is-small" }, [
                                _c("i", {
                                  staticClass: "mdi mdi-delete mdi-24px",
                                }),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ]),
                  ]
                )
              : _vm._e(),
          ]
        )
      }),
      !_vm.editable
        ? _c("template", { slot: "empty" }, [
            _c("section", { staticClass: "section" }, [
              _c(
                "div",
                { staticClass: "content has-text-grey has-text-centered" },
                [
                  _c("span", { attrs: { icon: "icon is-large" } }, [
                    _c("i", { staticClass: "mdi mdi-48px mdi-emoticon-sad" }),
                  ]),
                  _c("p", [_vm._v("Nothing")]),
                ]
              ),
            ]),
          ])
        : _vm._e(),
      _c("template", { slot: "footer" }, [
        _c("tr", [
          _c(
            "th",
            {
              staticClass: "left-right-items",
              attrs: { colspan: _vm.totalColSpan },
            },
            [
              _vm.editable
                ? _c("div", { staticClass: "left-item" }, [
                    _c(
                      "button",
                      {
                        staticClass: "button is-info is-rounded is-outlined",
                        attrs: { "data-tooltip": "add item" },
                        on: {
                          click: function ($event) {
                            return _vm.addBlankItem()
                          },
                        },
                      },
                      [
                        _c("span", { staticClass: "icon" }, [
                          _c("i", { staticClass: "mdi mdi-plus" }),
                        ]),
                        _c("span", [_vm._v("Add Item")]),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm.activeItems.length > 0
                ? _c(
                    "div",
                    {
                      staticClass: "has-text-right has-text-success right-item",
                    },
                    [_vm._v(" Totals ")]
                  )
                : _vm._e(),
            ]
          ),
          _vm.activeItems.length > 0
            ? _c(
                "th",
                {
                  class: [
                    _vm.total >= 0 ? "has-text-success" : "has-text-danger",
                  ],
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$filters.formatCurrency(
                        _vm.total,
                        _vm.$userInfo.locale
                      )
                    )
                  ),
                ]
              )
            : _vm._e(),
          _c("th", { attrs: { colspan: "100%" } }),
        ]),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }